<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="dialogRef.close()" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('billing.overlapDialog.title') }}</h2>
	<mat-dialog-content>
		<p class="whitespace-pre-wrap">{{ t('billing.overlapDialog.description') }}</p>
		<mat-list role="list">
			@for (segment of data.segments; track segment) {
				<mat-list-item role="listitem" class="hover:bg-gray-100 cursor-pointer" (click)="onSegmentSelected(segment)">
					<span class="font-semibold">{{ getValueString(segment) }}</span>
					<span class="text-sm text-gray-600 ml-4">
						{{ getDatesString(segment) }}
					</span>
				</mat-list-item>
			}
		</mat-list>
	</mat-dialog-content>
</div>
